(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.darkLogo = document.querySelector('.header__heading-logo-wrapper.logo-dark');
      this.lightLogo = document.querySelector('.header__heading-logo-wrapper.logo-light');
      this.ghostHeader = null;
      this.watchScroll = true;
      const scrollElement = document.querySelector('.scrollable-element');
      if (scrollElement) {
        this.ghostHeader = this.header;
        this.header = scrollElement;
      } else {
        this.header.classList.add('scrolled-past-header');
        this.lightLogo.classList.add('hidden');
        this.darkLogo.classList.remove('hidden');
        this.watchScroll = false;
      }
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.watchScroll) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.ghostHeader) {
          this.ghostHeader.classList.add('scrolled-past-header');
        }

        this.lightLogo.classList.add('hidden');
        this.darkLogo.classList.remove('hidden');

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (scrollTop <= this.headerBounds.bottom) {
        this.header.classList.remove('scrolled-past-header');
        if (this.ghostHeader) {
          this.ghostHeader.classList.remove('scrolled-past-header');
        }
        this.lightLogo.classList.remove('hidden');
        this.darkLogo.classList.add('hidden');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["map-block"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    let inTransition = false;
    function handleEvent(elem) {
      console.log('inTransition', inTransition);
      if (inTransition) return;
      inTransition = true;
      elem.classList.add('bg-brand-700');
      elem.classList.add('button__active');
      const tooltipId = elem.id.replace('block-', 'tooltip-');
      const tooltip = document.getElementById(tooltipId);

      const imageId = elem.id.replace('block-', '');

      const image = document.querySelector(`img[data-block-id="${imageId}"]`);
      const mainImage = document.querySelector('img[data-block-id="main-image"]');
      if (image) {
        image.style.opacity = '1';
        mainImage.style.opacity = '0.4';
      }
      tooltip.classList.remove('hidden');
      
      setTimeout(() => {
        tooltip.style.opacity = '1';
      }, 1);

      setTimeout(() => {
        console.log('inTransition set to false');
        tooltip.classList.add('tooltip__active');
        inTransition = false;
      }, 250);
      

      tooltip.focus();
    }

    function unhandleEvent(elem) {
      if (elem.classList.contains('tooltip__active') === false) return;
      if (inTransition) return;
      const buttonId = elem.id.replace('tooltip-', 'block-');
      const button = document.getElementById(buttonId);
      button.classList.remove('bg-brand-700');
      setTimeout(() => {
        elem.classList.add('hidden');
      }, 450);
      
      elem.classList.remove('tooltip__active');
      elem.style.opacity = '0';

      const imageId = elem.id.replace('tooltip-', '');

      const image = document.querySelector(`img[data-block-id="${imageId}"]`);
      const mainImage = document.querySelector('img[data-block-id="main-image"]');

      if (image) {
        image.style.opacity = '0';
        mainImage.style.opacity = '1';
      }
    }

    const buttons = document.querySelectorAll('[data-action="toggle-tooltip"]');
    buttons.forEach(button => {
      button.addEventListener('mouseenter', function() {
        console.log('mouseover', this);
        handleEvent(this);
      });

      button.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          const activeToolTip = document.querySelector('.tooltip__active');
          if (activeToolTip) {
            unhandleEvent(activeToolTip);
          }
          handleEvent(this);
        }
      });
    });

    const tooltips = document.querySelectorAll('[data-target="tooltip"]');
    tooltips.forEach(tooltip => {
      tooltip.addEventListener('mouseleave', function() {
        unhandleEvent(this);
      }); 
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
// JavaScript for tab functionality is included in the HTML section above.
  } catch(e) { console.error(e); }
})();
})();
